<template lang="pug">
div.element-container(@click="$emit('click')")
  .element
    v-img.rounded-lg(
      max-width="70px"
      height="70px"
      v-if="is_image"
      :src="url"
      @click="seeFullImage"
    )
    v-icon(v-else size="5rem" @click="seeFullDoc") {{ icon }}
    .element-actions(v-if="canDownload")
      v-btn.rounded.mr-1(@click="donwloadFile" color="primary" fab x-small)
        v-icon mdi-download

    .element-actions(v-if="showActions")
      v-btn.rounded.mr-1(v-if="showEdit" @click.stop="$emit('edit')" color="primary" fab x-small)
        v-icon mdi-pencil
      v-btn.rounded(@click.stop="$emit('delete')" color="error" fab x-small)
        v-icon mdi-close
  p.caption.mb-0.line-clamp-2 {{ name }}

  v-dialog(
    v-if="is_image"
    v-model="dialogStatus"
    persistent
    fullscreen
  )
    v-card
      v-card-title
        v-btn.rounded.ma-2(
          style="position=absolute"
          @click="closeDialog"
          fab color="error"
          x-small
        )
          v-icon mdi-close
        v-row(class="justify-center") {{ name }}
      v-img(
        :src="url"
        contain
        max-height="calc(100vh - 100px)"
        )
  v-card(v-else)
</template>

<script>
import { isImage } from '@/lib';
import axios from 'axios';

export default {
  components: {
  },
  props:{
    canDownload:{ type: Boolean, required:false, default: false },
    status:{ type:String, required:false, default: null },
    showActions: { type: Boolean, required:false, default: false },
    showEdit: { type: Boolean, required:false, default:true },
    name:{ type:String, required:false, default: 'Документ' },
    icon:{ type:String, required:false, default: 'mdi-file' },
    url:{ type:String, required:false, default: '' },
  },
  data() {
    return {
      dialogStatus: false,
    };
  },
  computed:{
    is_image() {
      return isImage(this.url);
    },
  },
  methods: {
    donwloadFile() {
      axios.get(this.url, { responseType: 'blob' })
        .then((response) => {
          let blob;
          if (!isImage(this.url)) blob = new Blob([response.data], { type: 'application/pdf' });
          if (isImage(this.url)) blob = new Blob([response.data], { type: 'image/png' });

          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = this.name;
          link.click();
          URL.revokeObjectURL(link.href);
        }).catch();
    },
    seeFullImage() {
      this.dialogStatus = true;
    },
    seeFullDoc() {
      window.open(this.url, '_blank');
    },
    closeDialog() {
      this.dialogStatus = false;
    },
  },
};
</script>

<style lang="scss">
$size: 100px;
$color: #444;

.line-clamp-2 {
  display: block;
  display: -webkit-box;
  word-wrap: break-word !important;
  max-width: 100%;
  line-height: 1;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.element-container{
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  min-width: $size;
  max-width: $size;
  margin-right: 20px;
  cursor: pointer;
  &:hover{
    .element-actions {
      display: flex;
      opacity: 1;
    }
  }
}

.element {
  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;
  border-radius: 0.1em;
  width: 100%;
  height: 5em;

  &-actions{
    transition: all 0.3s;
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0px;
  }
}
</style>
